import React, { useContext, useState, useEffect } from "react";
import { Translate } from "react-i18nify";
import { kioskstyles } from "./../../../../kioskstyles";
import "./../../../../font.css";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import { Capacitor } from "@capacitor/core";
import EsponPrinterPlugin from "./../../../../plugin/EsponPrinter";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";

import PrintDisabledIcon from "@mui/icons-material/PrintDisabled";
import { json } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function PrinterConnectionModal(props) {
  const [online, setOnline] = useState(true); //Should be true.
  const [errorMode, setErrorMode] = useState("GeneralError");

  const [lastRan, setLastRan] = useState(Date.now());

  useEffect(() => {
    handleGetPrinterStatus();
    const interval = setInterval(() => {
      handleGetPrinterStatus();
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const handleClickOpen = async () => {};
  const handleClose = async () => {};

  const handleGetPrinterStatus = async () => {
    let pluginResult = "";

    const epsonPrinterPluginAvailable = Capacitor.isPluginAvailable(
      "EpsonPrinter"
    );

    if (epsonPrinterPluginAvailable) {
      pluginResult = await EsponPrinterPlugin.getPrinterStatus({});

      setOnline(pluginResult.online);

      let ErrorMessage = "GeneralError";

      if (pluginResult.coverOpen) {
        ErrorMessage = "CoverOpen";
      }

      if (!pluginResult.connection) {
        ErrorMessage = "NotConnected";
      }

      setErrorMode(ErrorMessage);
    } else {
      setOnline(true);
    }
  };

  const throttledGetPrinterStatus = async () => {
    const delay = 1000;
    let now = Date.now();

    if (!lastRan || now - lastRan >= delay) {
      await setLastRan(now);
      await handleGetPrinterStatus();
    }
  };

  const kioskstyles = useKioskVerticalStyles();

  return (
    <React.Fragment>
      <Dialog
        open={!online}
        slots={{
          transition: Transition
        }}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            style={kioskstyles.modals.printererrormodal.body}
          >
            <div style={kioskstyles.modals.printererrormodal.title}>
              Printer Error
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center"
              }}
            >
              <PrintDisabledIcon
                style={kioskstyles.modals.printererrormodal.icon}
              />
            </div>
            {errorMode == "NotConnected" && (
              <div>
                <Translate value={"application.printererror.notconnected"} />
              </div>
            )}
            {errorMode == "CoverOpen" && (
              <div>
                <Translate value={"application.printererror.coveropen"} />
              </div>
            )}
            {errorMode == "GeneralError" && (
              <div>
                <Translate value={"application.printererror.generalerror"} />
              </div>
            )}
            <Button
              style={kioskstyles.modals.printererrormodal.buttonstyle}
              variant="outlined"
              onClick={throttledGetPrinterStatus}
            >
              <Translate value={"application.printererror.recheckbutton"} />
            </Button>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

export default PrinterConnectionModal;
